function swapSvg(e) {
  const targetLink = e.currentTarget;
  const svg = $(targetLink).data("svg");
  const resetSvg = $(targetLink).data("reset-svg");
  $(`.m__background.m__background--${svg}`).css("display", "inline-block");
  $(`.m__background.m__background--${resetSvg}`).css("display", "none");
}

function resetSvg(e) {
  const targetLink = e.currentTarget;
  const svg = $(targetLink).data("svg");
  const resetSvg = $(targetLink).data("reset-svg");
  $(`.m__background.m__background--${svg}`).css("display", "none");
  $(`.m__background.m__background--${resetSvg}`).css("display", "inline-block");
}

$(() => {
  $(".m-what-we-do .m__link")
    .mouseenter((e) => swapSvg(e))
    .mouseleave((e) => resetSvg(e));
});
